import { useMemo } from "react";
import { Printer, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { usePersons } from "@/hooks/usePersons";
import { findRoots } from "@/lib/tree";
import { TreeView } from "@/components/FamilyBranch";
import { t as tr } from "@/lib/i18n";

export default function PrintTree() {
  const { persons, t } = usePersons();
  const roots = useMemo(() => (persons ? findRoots(persons, t) : []), [persons, t]);
  return (
    <div className="px-4 sm:px-8 py-10 print-area">
      <div className="no-print max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-4 mb-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#52635B]" data-testid="print-back-link"><ArrowLeft className="w-4 h-4" />{tr("Back to tree")}</Link>
        <p className="text-sm text-[#7E8E85]">Tip: choose <b>Landscape</b> and <b>Save as PDF</b> in the print dialog. For a poster, pick A3 or larger.</p>
        <Button onClick={() => window.print()} className="rounded-full bg-[#1E3A2B] hover:bg-[#162C20] h-11 px-6" data-testid="print-btn"><Printer className="w-4 h-4 mr-2" />{tr("Print / Save as PDF")}</Button>
      </div>
      <div className="text-center mb-10">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D96B43]">{tr("Life long Jurny")}</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight mt-2">{tr("Vats Family Tree")}</h1>
        <p className="text-sm text-[#7E8E85] mt-2" data-testid="print-member-count">{persons?.length ?? 0} members · {new Date().toLocaleDateString(undefined, { month: "long", year: "numeric" })}</p>
      </div>
      <div className="overflow-x-auto print-tree" data-testid="print-tree">
        <div className="w-max mx-auto">{persons && <TreeView roots={roots} t={t} />}</div>
      </div>
    </div>
  );
}
